///////////////////////////////////////////////
//        Countdown timer styeling           //
///////////////////////////////////////////////

:host {
  @apply inline-flex;
}

.separator-design {
  --countdown-item--margin-right: 0;
  --countdown-item--margin-top-label: 0;
  --countdown-item--padding-number: 0;
}

::slotted(pk-divider) {
  @apply relative top-s ml-xs3 mr-xs3 h-[44px];
}

::slotted(*) {
  @apply relative font-semibold text-xl text-[color:--countdown-item--color-separator];
}
